module.exports = __webpack_public_path__ + "img/jazzy-thumbnail-fallback-cool.705e0b5.jpg";